/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBackground = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor">
      <path d="m15.303 17.283 1.98-1.98 1.414 1.414-1.98 1.98zm-10-10 1.98-1.98 1.414 1.414-1.98 1.98zm5.025 9.975 7-7 1.414 1.414-7 7zm-5-5 7-7 1.414 1.414-7 7z" />
      <path d="M2 2v20h20V2zm18 18H4V4h16z" />
      <path d="m5.282 17.303 12.02-12.02 1.415 1.414-12.02 12.02z" />
    </g>
  </Icon>
);
export { SvgBackground as Background };
